import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "./styling/bootstrap4-main.scss";
import "./styling/bootstrap3-scoped.css";
import { IConfig } from "./lib/config";

declare global {
  interface Window {
    zEmbed?: {
      (callback: () => void): void;
      activate(activate: boolean): void;
      setLocale(locale: string): void;
    };
    FreshworksWidget?: any;
    CONFIG?: IConfig;
  }
}

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
